import { ProtectedRoute } from './components/Auth';
import { DashboardPage } from './pages/Dashboard/DashboardPage';

function App() {
  return (
    <ProtectedRoute>
      <DashboardPage />
    </ProtectedRoute>
  );
}

export default App;
